import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import coverImg from "../../Assets/images/nocover.png";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import "./BookDetails.css";

const BookDetails = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [book, setBook] = useState(null);
  const navigate = useNavigate();
  const URL = `https://openlibrary.org/works/`; // Base URL for fetching book details

  useEffect(() => {
    setLoading(true);
    async function getBookDetails() {
      try {
        const response = await fetch(`${URL}${id}.json`);
        const data = await response.json();
        console.log(data);

        if (data) {
          const {
            description,
            title,
            covers,
            subjects_places,
            subject_times,
            subjects,
            availability,
          } = data;

          const newBook = {
            description: description
              ? description.value
              : "No description found",
            title: title,
            coverImg: covers
              ? `https://covers.openlibrary.org/b/id/${covers[0]}-L.jpg`
              : coverImg,
            subjects_places: subjects_places
              ? subjects_places.join(", ")
              : "no subject places",
            subject_times: subject_times
              ? subject_times.join(", ")
              : "no subject times",
            subjects: subjects ? subjects.join(", ") : "no subjects",
            link:
              availability?.openlibrary?.preview_url ||
              `https://openlibrary.org${data.key}`, // Generate the link to the book page or readable text
          };

          setBook(newBook);
        } else {
          setBook(null);
        }
        setLoading(false);
      } catch (error) {
        console.log(error);
        setLoading(false);
      }
    }
    getBookDetails();
  }, [id, URL]);

  console.log(book);

  return (
    <section className="book-details">
      <div className="container">
        <button
          type="button"
          className="flex flex-c back-btn "
          onClick={() => navigate("/book")}
        >
          <FaArrowLeft size={22} />
          <span className="fs-18 fw-6">Go back</span>
        </button>

        {loading && <p>Loading...</p>}

        {!loading && book && (
          <div className="book-details-content grid">
            <div className="book-details-img">
              <img src={book.coverImg} alt="cover img" />
            </div>

            <div className="book-details-info">
              <div className="book-details-item title">
                <span className="fw-6 fs-24">{book.title}</span>
              </div>
              <div className="book-details-item description">
                <span className="fw-6 fs-24">{book.description}</span>
              </div>
              <div className="book-details-item">
                <span>Subject Places: </span>
                <span className="text-italic">{book.subjects_places}</span>
              </div>
              <div className="book-details-item">
                <span>Subject Times: </span>
                <span className="text-italic">{book.subject_times}</span>
              </div>
              <div className="book-details-item">
                <span>Subjects: </span>
                <span className="text-italic">{book.subjects}</span>
              </div>
              <div className="book-details-item">
                <a href={book.link} target="_blank" rel="noopener noreferrer">
                  See full details <FaArrowRight />
                </a>
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default BookDetails;
